import Vue from 'vue'
import { mapMutations } from 'vuex'

Vue.mixin({
  computed: {
    crumbs: () => null
  },
  watch: {
    crumbs () {
      this.SET_CRUMBS(this.crumbs)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.SET_CRUMBS(vm.crumbs)
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.SET_CRUMBS(this.crumbs)
    next()
  },
  methods: {
    ...mapMutations('crumbs', ['SET_CRUMBS'])
  }
})
